module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"gender-male":"Мужской","gender-female":"Женский","gender-unisex":"Унисекс"}}')
  delete Component.options._Ctor
}
